import { render, staticRenderFns } from "./M2hNewsFeed.vue?vue&type=template&id=56a94252&scoped=true&"
import script from "./M2hNewsFeed.vue?vue&type=script&lang=js&"
export * from "./M2hNewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a94252",
  null
  
)

export default component.exports